import classNames from 'classnames';
import { Icon } from 'palette/Icon';
import { BodyText, Header } from 'palette/Typography';
import { useConfig } from '@common/Hooks/useConfig';
import { BEMBlock } from '@helpers/classnames';
import { isWebshopMobile } from '@helpers/env';
import '../styles/GlobalSearchNoResultPage.scss';

interface GlobalSearchNoResultPageProps {
    isEmptyResult: boolean;
    subtitle: string;
    title: string;
}

export function GlobalSearchNoResultPage({
    isEmptyResult,
    subtitle,
    title,
}: GlobalSearchNoResultPageProps) {
    const config = useConfig();
    const isMobileView = isWebshopMobile(config);
    const [block, BEMElement] = BEMBlock('global-search-no-result-page');

    return (
        <div className={classNames(block)}>
            <div className={BEMElement('icon-container')}>
                <Icon
                    className={BEMElement('icon')}
                    name="palette_search"
                    size={isMobileView ? 'medium' : 'x-large'}
                />
            </div>
            <Header
                level="5"
            >
                {title}
            </Header>
            {isEmptyResult && (
                <BodyText
                    color="light"
                    level="1"
                >
                    {subtitle}
                </BodyText>
            )}
        </div>
    );
}
